import { useGetMetabaseQuery } from "@/services/metabase/metabase";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { Load } from "components/load";
import { ArrowLeft, RefreshCw } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CONCILIATION_REPORTS_ID = 3;

const Report = () => {
  const navigate = useNavigate();
  const navigateBack = () => navigate("/conciliacao/lojas/");

  const id = CONCILIATION_REPORTS_ID;
  const { data, error, isLoading, refetch } = useGetMetabaseQuery({ id });

  if (isLoading) return <Load />;

  if (error)
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <button
          onClick={() => refetch()}
          className="px-4 py-2 border border-black/20 flex items-center gap-2 rounded-md
          text-black bg-white
          transition-all duration-300 ease-in-out
          hover:bg-gray-100 hover:border-gray-400
          focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50"
        >
          <RefreshCw className="w-5 h-5" />
          Tentar novamente
        </button>
      </div>
    );

  return (
    <PageLayout>
      <PageTitle title="Painel de Monitoramento" description="Visualize os dados de conciliação de forma controlada." />
      <ContentContainer>
        <iframe src={data} frameBorder="0" className="w-full h-[3800px]"></iframe>
        <div className="w-full flex items-center justify-between bg-white rounded-md">
          <button
            className="self-end w-max px-4 py-2 border border-black/20 flex items-center gap-2 rounded-md
         text-black bg-white
         transition-all duration-300 ease-in-out
         hover:bg-[#2B0C1A] hover:text-white hover:border-transparent
         "
            onClick={navigateBack}
          >
            <ArrowLeft className="w-5 h-5" />
            Voltar
          </button>
          <button
            className="px-4 py-2 border border-gray-300 flex items-center gap-2 rounded-md
          text-gray-700 bg-white
          transition-all duration-300 ease-in-out
          hover:bg-gray-100 hover:border-gray-400
          focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50"
            onClick={() => refetch()}
            disabled={isLoading}
          >
            <RefreshCw className="w-5 h-5" />
            Atualizar dados
          </button>
        </div>
      </ContentContainer>
    </PageLayout>
  );
};

export default Report;
